var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullWidthImageContainer",class:_vm.alignmentClass},[_c('img',{attrs:{"src":_vm.image.sizes['ct-extra-large']}})])}
var staticRenderFns = []

export { render, staticRenderFns }